import styled from '@emotion/styled';

import { Section } from '@/components/layout/Section';

export interface CodeSnippetProps {
  htmlCode: string;
}

const CodeSnippet = ({ htmlCode }: CodeSnippetProps) => {
  return (
    <Section breakout>
      <Container>
        <CodeContainer>
          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: htmlCode }} />
        </CodeContainer>
      </Container>
    </Section>
  );
};

const Container = styled.div`
  max-width: 800px;
  p {
    margin-bottom: var(--spacing-small);
  }
`;

const CodeContainer = styled.div`
  margin: var(--spacing-large) 0;
  iframe {
    width: 100%;
  }
  .hbspt-form {
    label {
      line-height: 30px;
      .hs-form-required {
        color: red;
      }
    }
    input,
    select {
      border: 1px solid #cbd6e2;
      min-height: 40px;
      background-color: #f5f8fa;
      color: #33475b;
      padding: 0 15px;
      border-radius: 3px;
      margin-bottom: 10px;
    }
    input[type='submit'] {
      margin-top: 10px;
      background: #1d98ff;
      border-color: #1d98ff;
      color: #ffffff;
      cursor: pointer;
    }
  }
`;
export { CodeSnippet };
